// extracted by mini-css-extract-plugin
var _1 = "Problem__engineBg--hMVfV TrainerGeneral__engineBg--pzNDN CoreGeneral__engineBg--j2tiG";
var _2 = "Problem__large--vfI71";
var _3 = "Problem__main--ick6l TrainerGeneral__engineOuter--vJslo CoreGeneral__engineOuter--jw7Df";
export { _1 as "engineBg", _2 as "large", _3 as "main" }
